import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { Flex } from 'foundations-components/components/Flex';
import { ButtonWrapper } from 'foundations-components/transitional/components/ButtonWrapper';
import { Link } from 'foundations-components/transitional/components/Link';
import { HelpIcon } from 'foundations-components/transitional/components/HelpIcon';
import InlineFeedback from 'ai-components-ui-library/components/feedback/InlineFeedback';
import UsageTracker from '../../../utils/UsageTracker';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ExternalIcon = () => null;
const CompanionFooter = ({
  additionalButtons,
  contentId,
  contentType,
  trackingAction
}) => {
  const handleCustomFeedback = e => {
    // `ratingInteraction` expects `ratingScore` to be 1 | 2 | 3
    // `vote` is -1 | 1 so we are just adjusting here accordingly
    const ratingScore = e.vote === 1 ? 2 : 1;
    UsageTracker.trackStandalone('Rating Interaction', {
      action: trackingAction,
      contentId,
      contentType,
      feedbackText: e.feedbackMessage,
      ratingReason: e.options,
      ratingScore,
      view: 'desktop'
    });
  };
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    borderBlockStartColor: "border-core-subtle",
    borderBlockStartStyle: "solid",
    borderBlockStartWidth: "100",
    justifyContent: "space-between",
    paddingBlock: "400",
    paddingInline: "700",
    children: [/*#__PURE__*/_jsx(ButtonWrapper, {
      horizontalGap: 16,
      children: /*#__PURE__*/_jsx(InlineFeedback
      // TODO: Placeholder for now while we don't have a `messageId`. This is the `trajectoryId` from BE
      , {
        messageId: "",
        onNegativeFeedback: handleCustomFeedback,
        onPositiveFeedback: handleCustomFeedback,
        usageTracker: "WE HAVE CUSTOM TRACKING IN PLACE AND AI-EXTENSIBILITY TEAM IS AWARE"
      })
    }), /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "learningCenter.interactiveEducation.disclaimer",
      options: {
        link: /*#__PURE__*/_jsx(HelpIcon, {
          title: "",
          children: /*#__PURE__*/_jsx(Link, {
            ExternalIcon: ExternalIcon,
            external: true,
            href: "https://legal.hubspot.com/hubspot-beta-terms",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "learningCenter.interactiveEducation.seeTerms"
            })
          })
        })
      }
    }), additionalButtons]
  });
};
export default CompanionFooter;